// extracted by mini-css-extract-plugin
export default {"root":"root--6eX_Q","color":"color--RhqDd","flex":"flex--B9F5Z","container":"container--jyzt1"};